import { Box, Stack } from '@mui/material'
import foodsIcon from 'assets/Foods.png'
import { IGroupEntity } from '../../models/IGroup'

import TabsFilter from 'ui/breadCrumbs/TabsFilter'

import CattlesList from 'components/cattles/cattlesPage/ui/CattlesList'
import { useTabsController } from 'hooks/useTabsController'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { showMilkYieldUi } from 'utils/companyMilkFeatures'
import GroupSpecificConsuptionChart from './consuption/GroupSpecificConsuptionChart'
import FatnessCard from './fatness-card/FatnessCard'
import GroupSpecificFoodtableAvailable from './food-available/GroupSpecificFoodtableAvailable'
import { LamenessCard } from './lameness-card/LamenessCard'
import { MainInfo } from './main-info/MainInfo'
import { MilkingYieldBlock } from './milking-yield-block/MilkingYieldBlock'
import { EditGroupTooltip } from './shared/EditGroupTooltip'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'

export enum TABS_GROUP_PAGE {
	MAIN_INFORMATION = 'main_information',
	COWS_LIST = 'cows_list',
	HEALTH = 'health',
	MILK_YIELD = 'milk_yield',
	FOOD_TABLE = 'food_table',
}

const GroupSpecific = (props: IGroupEntity) => {
	const { tab, changeTab } = useTabsController<TABS_GROUP_PAGE>({
		keyName: 'tab',
		defaultValue: TABS_GROUP_PAGE.MAIN_INFORMATION,
	})
	const { permissions } = useAppSelector(state => state.authReducer)
	const { userData } = useAppSelector(state => state.userReducer)
	const hasDigitizationLicense =
		permissions?.license_identification ||
		permissions?.license_fatness ||
		permissions?.license_limpness
	const canShowMilkYield =
		hasDigitizationLicense && showMilkYieldUi(userData?.company?.id)

	const tabOptions = [
		{
			key: TABS_GROUP_PAGE.MAIN_INFORMATION,
			title: 'Общая информация',
		},
		{
			key: TABS_GROUP_PAGE.COWS_LIST,
			title: 'Список голов',
		},
		...(permissions?.license_food_table
			? [
					{
						key: TABS_GROUP_PAGE.FOOD_TABLE,
						title: 'Кормовой стол',
					},
				]
			: []),
		...(permissions.license_limpness || permissions.license_fatness
			? [
					{
						key: TABS_GROUP_PAGE.HEALTH,
						title: 'Здоровье',
					},
				]
			: []),
		...(canShowMilkYield
			? [
					{
						key: TABS_GROUP_PAGE.MILK_YIELD,
						title: 'Надои',
					},
				]
			: []),
	]

	const renderContent = (currentTab: TABS_GROUP_PAGE) => {
		switch (currentTab) {
			case TABS_GROUP_PAGE.MAIN_INFORMATION:
				return <MainInfo {...props} />
			case TABS_GROUP_PAGE.COWS_LIST:
				return <CattlesList activeFilter={props.id} isGroupPage />
			case TABS_GROUP_PAGE.HEALTH:
				return (
					<>
						{permissions.license_limpness && (
							<LamenessCard groupId={props.id} />
						)}
						{permissions.license_fatness && <FatnessCard groupId={props.id} />}
					</>
				)

			case TABS_GROUP_PAGE.MILK_YIELD:
				return (
					<MilkingYieldBlock
						groupId={props.id}
						barnId={props.barn}
						cattleCount={props.cattles_qty}
					/>
				)
			case TABS_GROUP_PAGE.FOOD_TABLE:
				return (
					<>
						<GroupSpecificFoodtableAvailable id={props.id} group_title={''} />
						<GroupSpecificConsuptionChart group_id={props.id} />
					</>
				)
		}
	}

	return (
		<Box
			sx={{
				display: 'grid',
				width: '100%',
				height: '100%',
				gap: '24px',
				boxSizing: 'border-box',
				paddingRight: '30px',
				paddingLeft: '10px',
			}}
		>
			{permissions?.license_food_table && !props.rationtitle && (
				<Stack
					direction='row'
					alignItems='center'
					gap='12px'
					sx={{
						padding: '22px 20px',
						borderRadius: '12px',
						backgroundColor: COLORS.white,
						boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.08)',
					}}
				>
					<img src={foodsIcon} alt='' width={24} height={24} />
					<Box>
						<TypographyPrimary>Рацион не назначен группе.</TypographyPrimary>
						<TypographyPrimary>
							Назначьте рацион, чтобы расчёт ПСВ, раздач и остатков выполнялся
							корректно.
						</TypographyPrimary>
					</Box>
				</Stack>
			)}
			<Stack
				direction='row'
				alignItems='center'
				justifyContent='space-between'
				sx={{
					borderBottom: `1px solid ${COLORS.inputBorder}`,
				}}
			>
				<TabsFilter
					availableTabs={tabOptions}
					onClick={key => changeTab(key as TABS_GROUP_PAGE)}
					selectedKey={tab}
					showDivider={false}
				/>
				<EditGroupTooltip groupId={props.id} />
			</Stack>
			{renderContent(tab)}
			{/*
			{permissions.license_limpness && <LamenessCard groupId={props.id} />}
			{permissions.license_fatness && <FatnessCard groupId={props.id} />}
			{permissions.license_food_table && (
				<>
					<Gr
					oupSpecificFoodtableAvailable
										
					/>
					<GroupSpecificConsuptionChart group_id={props.id} />
				</>
			)} */}

			{/* <GroupSpecificDeviationList
				id={props.id}
				ref={sectionRefs['deviations-list']}
			/> */}

			{/* <GroupSpecificFeedPlan
				group_id={props.id}
				ref={sectionRefs['feed-plan']}
			/> */}

			{/* <GroupSpecificHeadChart
						groupkey={props.groupkey}
				group_id={props.id}
				ref={sectionRefs['head-qty']}
			/> */}

			{/* <GroupSpecificDryIntake
				groupkey={props.groupkey}
				group_id={props.id}
				ref={sectionRefs['dry-intake']}
			/> */}
		</Box>
	)
}

export default GroupSpecific
